<template>
    <div id="EducationSection1">
    <view1/>
    <view2/>

    </div>

</template>
<script>
    export default {
        name: 'EducationSection1',
        components: {
            // 异步加载子组件
            view1: () => import('@/views/EducationSection1/view1.vue'),
            view2: () => import('@/views/EducationSection1/view2.vue')
        }
    }
</script>
<style scoped>
</style>

